import { render } from "./AzureIcon.vue?vue&type=template&id=3c36feba&scoped=true"
import script from "./AzureIcon.vue?vue&type=script&lang=js"
export * from "./AzureIcon.vue?vue&type=script&lang=js"

import "./AzureIcon.vue?vue&type=style&index=0&id=3c36feba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c36feba"]])

export default __exports__